import React from 'react';
import Button from '../../components/common/Button';

interface ActionButtonProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

const ActionButton: React.FC<ActionButtonProps> = ({ label, onClick, disabled = false }) => (
  <Button
    variant="ghost"
    size="md"
    disabled={disabled}
    className="btn--full manage-competition-action"
    onClick={onClick}
  >
    <span className="manage-competition-action__label">{label}</span>
    <span className="manage-competition-action__chevron" aria-hidden="true">›</span>
  </Button>
);

export default ActionButton;
